const binding = { modules: {}, dataActions: {} };

    (binding.modules['mfrm-email-subscription-modal'] = {
        c: () => require('partner/modules/mfrm-email-subscription-modal/mfrm-email-subscription-modal.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-email-subscription-modal',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-email-subscription-modal'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-email-subscription-modal|mfrm-email-subscription-modal'] = {
                c: () => require('partner/modules/mfrm-email-subscription-modal/mfrm-email-subscription-modal.view.tsx'),
                cn: '__local__-__local__-mfrm-email-subscription-modal'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };